export default "__VITE_ASSET__CVYqk24r__"